import React from 'react'

const HomeToxicologyResults = () => {
  return (
    <div id='website-responsive' style={{ backgroundImage:'', height:'100%', width:'100%'}}>
    <div className='left-padding6rem right-padding6rem p-top-bottom2rem bg-img'>
        <div className=''>
            <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700'>
                ACCURATE TOXICOLOGY TESTING AT YOUR COMFORT
            </text>
            <hr className='hr-style' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
        </div>
        <div className='pb-2'>
            <text className='fs-ss-18-3 fw-600 text-montserrat text-ss-black' style={{ fontStyle:'italic'}} >
                Our drug panel test detects 15 toxins & over 100 different drugs.
            </text>
        </div>

        <div className='py-2'>
            <text className='fs-ss-16 text-ss-black fw-600 text-montserrat' style={{ letterSpacing:'0.5px'}}>
                Toxicology testing is a crucial medical screening process that involves the analysis of biological samples, such as urine, blood, or hair, to detect the presence of drugs, alcohol, or other toxic substances in the body. This type of testing serves various purposes, including workplace drug screening, forensic investigations, and monitoring patients undergoing medication or substance abuse treatments.
            </text>
        </div>

        <div className='py-4'>
            <text className='fs-ss-16 text-ss-black fw-600 text-montserrat' style={{ letterSpacing:'0.5px'}}>
                At United Lab Care, we recognize the importance of toxicology testing in promoting safety, well-being, and adequate medical management. Our skilled professionals are committed to providing accurate and timely toxicology testing services. Prioritize safety and wellness with our toxicology testing. Get accurate results to make informed decisions. Schedule your test now!
            </text>
        </div>

        <div className=''>
            <text className='fs-ss-16 text-ss-black fw-600 text-montserrat' style={{ letterSpacing:'0.5px'}}>
                With United Lab Care as your partner, you can rest assured that your toxicology testing needs will be handled with the utmost care, professionalism, and dedication to accuracy. Our commitment to reliable testing services contributes to a safer and healthier community, empowering individuals, and organizations alike to make informed choices and take proactive steps toward better health outcomes.
            </text>
        </div>

        <div className='display-block1'>
            <div className='' style={{ display:'flex', justifyContent:'center'}}>
                <img src='https://unitedlabcare.com/wp-content/uploads/2022/12/About-Us-img2-v1.webp' alt='Toxicology' width='90%' />
            </div>
        </div>
    </div>
</div>
  )
}

export default HomeToxicologyResults